import DeleteIcon from '@atlaskit/icon/core/delete';
import { token } from '@atlaskit/tokens';
import { analyticsClient } from '@databases/analytics';
import { messages } from '@databases/intl/messages';
import { legacyColors as colors } from '@databases/utils/legacy-colors';
import React from 'react';

import { deleteEntries } from '../actions/delete-entries.ts';
import { type MenuItemBuilder, SELECT_VALUE_MENU_ACTIONS } from '../types.ts';

export const deleteEntriesMenuItem: MenuItemBuilder = ({
  capabilities: { canDeleteEntries },
  formatMessage,
  selectedEntriesCount,
  isHoverDeleteEntriesButton,
  contentId,
  selectedEntryIds,
  panelManager,
  selectionsActions
}) => {
  const { entryId: panelEntryId } = panelManager.getData('EntryViewPanel') || {};

  return {
    isEnabled: () => canDeleteEntries,
    menuItem: {
      key: SELECT_VALUE_MENU_ACTIONS.DELETE_ENTRIES,
      content: formatMessage(messages['entry-actions.delete'], {
        entryCount: selectedEntriesCount.toString()
      }),
      onClick: () => {
        deleteEntries({
          contentId,
          client: analyticsClient,
          hidePanel: panelManager.hidePanel,
          panelEntryId
        });
        selectionsActions.clearSelectionIntent();
      },
      onMouseEnter: () => {
        selectionsActions.setSelectionIntent({ type: 'delete', target: 'entries' });
        selectionsActions.selectEntries(selectedEntryIds, {
          clearSelectedValues: false
        });
      },
      onMouseLeave: () => {
        selectionsActions.clearSelectionIntent();
        selectionsActions.selectEntries([], { clearSelectedValues: false });
      },
      elemBefore: (
        <DeleteIcon
          label=""
          color={
            isHoverDeleteEntriesButton
              ? token('color.icon.danger', colors.R500)
              : undefined
          }
        />
      )
    }
  };
};
